/* eslint-disable react-hooks/exhaustive-deps */
import { memo, useEffect, useState } from 'react';

// Utils
import { useNavigate, useParams } from 'react-router-dom';
import { isActionableForUser } from '../../../../utils/validateRole';

// Components
import EventInscriptionContainer from './container';
import Loader from '../../../../components/layout/loader';

// Interfaces
import type { Evento } from '../../../../interfaces/evento';

// Redux
import { useAppDispatch, useAppSelector } from '../../../../store/store';
import { pendingRegistrationModalActions } from '../../../../store/slices/pendingRegistrationModal';

// Services
import EventoService from '../../../../services/eventos.service';
import { InscripcionService } from '../../../../services/inscripciones.service';

// Utils
import dayjs from 'dayjs';
import { getEventoIdFromUrl, getEventoUrlId } from '../../../../utils/eventoId';

// Constants
import { PAGE_TITLE } from '../../../../constants/page';
import { ROUTES } from '../../../../constants/routes-constants';
import { PERMISSIONS } from '../../../../constants/permissions';

export const EventInscriptionPage = memo(() => {
  const params = useParams<{ id: string }>();
  const user = useAppSelector((state) => state.auth.user);

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState<boolean>(true);
  const [evento, setEvento] = useState<Evento | null>(null);

  useEffect(() => {
    setLoading(true);

    if (!user) {
      navigate(ROUTES.LOGIN_ROUTE);
      return;
    }

    if (!user.entidad) {
      navigate(ROUTES.EVENT_DETAILS_ROUTE.replace(':id', getEventoIdFromUrl(params.id!)));
      dispatch(pendingRegistrationModalActions.setPendingRegistrationModal(true));
      return;
    }

    const request = !isActionableForUser(user!, [PERMISSIONS.EVENTOS_READ])
      ? EventoService.getPublicEventById
      : EventoService.getEventoById;

    request(Number(getEventoIdFromUrl(params.id!)))
      .then((response) => {
        const cantRegister =
          dayjs().isAfter(dayjs(response.inscripcion_fin)) ||
          dayjs().isBefore(dayjs(response.inscripcion_inicio));
        if (cantRegister) {
          navigate(ROUTES.EVENT_DETAILS_ROUTE.replace(':id', response.id.toString()));
        }

        setEvento(response as Evento);
        document.title = `${PAGE_TITLE} | ${response.nombre} | Inscripción`;
      })
      .finally(() => setLoading(false));
  }, [params.id, user]);

  useEffect(() => {
    if (evento && user) {
      InscripcionService.isInscripted(evento.id).then((response) => {
        if (response.isInscripted) {
          navigate(ROUTES.EVENT_DETAILS_ROUTE.replace(':id', getEventoUrlId(evento)));
        }
      });
    }
  }, [evento, user]);

  if (loading) return <Loader />;

  return <EventInscriptionContainer evento={evento!} />;
});

EventInscriptionPage.displayName = 'EventInscriptionPage';

export default EventInscriptionPage;
